var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-container mt-2"},[_c('svg',{ref:"chart",staticClass:"chart",attrs:{"height":"300px","width":"100%"}},[_c('polyline',{attrs:{"fill":"none","stroke":"rgba(0,0,0,0.8)","stroke-width":"1.5","points":_vm.points}})])])}
var staticRenderFns = []

export { render, staticRenderFns }